import { useEffect, useState } from 'react';

function useDebounce(value, delay) {
  // State and setters for debounce value
  const [debounceValue, setDebounceValue] = useState(value);

  useEffect(
    () => {
      // Update debounce value after delay
      const handler = setTimeout(() => {
        setDebounceValue(value);
      }, delay);

      // Cancel the timeout if value changes (also on delay change or unmounted)
      // This is how we prevent debounce value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler);
      };
    },

    // eslint-disable-next-line
    [value, delay], // Only re-call effect if value or delay changes
  );

  return debounceValue;
}

export default useDebounce;
